// extracted by mini-css-extract-plugin
export default {"error":"FormInput_error__zV6gc"};